import { GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED } from '@common/neo.tax';

import { stringifyCsv } from '@neo.tax/shared/utils';

const headers = Object.values(GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED);
export const HEADERS_STRINGIFIED = stringifyCsv([headers]);

const exampleData = [
  headers,
  [
    'Maya Angelou',
    'Chief Editor',
    'Marketing',
    'maya-employee-id',
    'mikasa-employee-id',
    'mangelou@example.com',
    '$60,000.00',
    '',
    'CA',
    'United States',
    '5/15/23',
    '',
    '1101 - R&D',
    '',
  ],
  [
    'Louis Armstrong',
    'Backend Engineer',
    'Software Development',
    'louis-employee-id',
    'thomas-employee-id',
    'larmstrong@example.com',
    '$115,000.00',
    '',
    'AZ',
    'United States',
    '1/1/22',
    '12/15/23',
    '1101 - R&D',
    'France Holding Co',
  ],
  [
    'Reiner Braun',
    'UI/UX Designer',
    'Design',
    'reiner-employee-id',
    '',
    'rbraun@example.com',
    '',
    '$35,500.00',
    'NY',
    'United States',
    '1/1/22',
    '',
    '1101 - R&D',
    'Manufacturing LLC',
  ],
  [
    'Taylor Swift LLC',
    'Outsourced CFO',
    'Finance',
    'taylor-employee-id',
    '',
    'tswift@example.com',
    '',
    '$67,456.88',
    '',
    'Canada',
    '1/1/22',
    '',
    '1101 - R&D',
    'US Corporate',
  ],
  [
    'Mikasa Ackerman',
    'Marketing Director',
    'Marketing',
    'mikasa-employee-id',
    'rakhshaan-employee-id',
    'mackerman@example.com',
    '$84,000.00',
    '',
    'CA',
    'United States',
    '1/1/22',
    '',
    '1101 - R&D',
    'US Corporate',
  ],
  [
    'Johann Bach',
    'Frontend Engineer',
    'Software Development',
    'johann-employee-id',
    'thomas-employee-id',
    'jbach@example.com',
    '$84,300.00',
    '',
    'CA',
    'United States',
    '1/1/22',
    '',
    '1101 - R&D',
    '',
  ],
  [
    'Rakhshaan Adamjee',
    'CFO',
    'Finance',
    'rakhshaan-employee-id',
    '',
    'radamjee@example.com',
    '$110,000.00',
    '',
    'CA',
    'United States',
    '7/14/18',
    '',
    '1101 - R&D',
    '',
  ],
  [
    'Joshua Zhou',
    'Product Manager',
    'Product Development',
    'joshua-employee-id',
    '',
    'jzhou@example.com',
    '$150,000.00',
    '',
    'IL',
    'United States',
    '9/1/18',
    '8/1/22',
    '1204 - Data',
    '',
  ],
  [
    'Darlene Snell',
    'Software Engineer',
    'Software Development',
    'darlene-employee-id',
    'thomas-employee-id',
    'dsnell@example.com',
    '$95,000',
    '',
    'CA',
    'United States',
    '8/8/19',
    '4/1/23',
    '1204 - Data',
    '',
  ],
  [
    'Zoro Roronoa',
    'Sales',
    'Sales',
    'zoro-employee-id',
    '',
    'zroronoa@example.com',
    '$65,600.00',
    '',
    'CA',
    'United States',
    '10/2/19',
    '',
    '1204 - Data',
    '',
  ],
  [
    'Alexander Hamilton',
    'Customer Success',
    'Customer Success',
    'alexander-employee-id',
    '',
    'ahamilton@example.com',
    '$74,300.00',
    '',
    'CA',
    'United States',
    '',
    '',
    '303 - Intel',
    '',
  ],
  [
    'Gon Freecss',
    'Project Manager',
    'Product Development',
    'gon-employee-id',
    'joshua-employee-id',
    'gfreecss@example.com',
    '$145,600.00',
    '',
    'AZ',
    'United States',
    '',
    '',
    '303 - Intel',
    '',
  ],
  [
    'Thomas Bruner',
    'VP of Engineering',
    'Software Development',
    'thomas-employee-id',
    '',
    'tbruner@example.com',
    '$162,500.00',
    '',
    'TX',
    'United States',
    '',
    '',
    '303 - Intel',
    '',
  ],
  [
    'Leah Smith',
    'Software Developer',
    'Software Development',
    'leah-employee-id',
    'thomas-employee-id',
    'lsmith@example.com',
    '$112,500.00',
    '',
    'CA',
    'United States',
    '',
    '',
    '104 - Ops',
    '',
  ],
  [
    'Leila Mogler',
    'Graphic Designer',
    'Marketing',
    'leila-employee-id',
    'mikasa-manager-employee-id',
    'lmogler@example.com',
    '$79,500.00',
    '',
    '',
    'United Kingdom',
    '',
    '',
    '104 - Ops',
    '',
  ],
];

export const EXAMPLE_DATA_STRINGIFIED = stringifyCsv(exampleData);
